import React from "react";

import "./Typography.css";

export const PageHeadline = ({ children }) => (
  <h1 className="pageHeadline">{children}</h1>
);

export const PageTagline = ({ children }) => (
  <h2 className="pageTagline">{children}</h2>
);

export const PageIntroduction = ({ children }) => (
  <p className="pageIntroduction">{children}</p>
);

export const SectionHeadline = ({ children }) => (
  <h2 className="sectionHeadline">{children}</h2>
);

export const ColumnHeadline = ({ children }) => (
  <h3 className="columnHeadline">{children}</h3>
);

export const SectionKicker = ({ children }) => (
  <h4 className="sectionKicker">{children}</h4>
);

export const SectionIntroduction = ({ children }) => (
  <p className="sectionIntroduction">{children}</p>
);



// WEBPACK FOOTER //
// ./src/components/Typography.js